export default {
  props: {
    isCollapsible: {
      type: Boolean,
      default: false,
    },
    defaultCollapsed: {
      type: Boolean,
      default: false,
    },
    displayAction: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCollapsed: this.defaultCollapsed,
    };
  },
  computed: {
    contentIsCollapsed() {
      return this.isCollapsible && this.isCollapsed;
    },
  },
  methods: {
    toggleIsCollapsed() {
      this.isCollapsed = !this.isCollapsed;
    },
  },
};
